exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  CHARTJS */\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/chartjs/chartjs.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/chartjs/chartjs.css
// module chunks = styles